import styled, { css } from 'styled-components';

import { descriptionStyles, errorMessageStyles } from '../style/xemplo-input.text';

/**
 * Base styles for an error message element.
 * @deprecated Use `errorMessageStyles` instead.
 * Leaving for backward compatibility.
 */
export const errorMessageBase = css`
  ${errorMessageStyles};
`;

/**
 * Base styles for a description element.
 * @deprecated Use `descriptionStyles` instead.
 * Leaving for backward compatibility.
 */
export const descriptionBase = css`
  ${descriptionStyles};
`;

/** A div element that contains the error styling */
export const ErrorMessage = styled.div.attrs({ role: 'alert' })`
  ${errorMessageStyles};
`;

export const Description = styled.div`
  ${descriptionStyles};
`;
